import { useRef } from 'react'

import { useEmailMessageCompletedRealtime } from '../../../Email'

export function useRequestProfileEmailsRealtime({
  channel,
  enabled = true,
  onReloadListExtra,
}) {
  const listenerRef = useRef(null)

  function registerEmailsRealtimeListener(listener) {
    listenerRef.current = listener
  }

  function handleMessageCompleted(payload) {
    onReloadListExtra?.()
    listenerRef.current?.onMessageCompleted?.(payload)
  }

  function handleInitialSubscribe() {
    listenerRef.current?.onInitialSubscribe?.()
  }

  function handleResync() {
    onReloadListExtra?.()
    listenerRef.current?.onResync?.()
  }

  useEmailMessageCompletedRealtime({
    channel,
    enabled,
    onInitialSubscribe: handleInitialSubscribe,
    onMessageCompleted: handleMessageCompleted,
    onResync: handleResync,
  })

  return { registerEmailsRealtimeListener }
}
